import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-broadcastings-new-broadcasting',
  templateUrl: './broadcastings-new-broadcasting.component.html',
  styleUrls: ['./broadcastings-new-broadcasting.component.scss']
})
export class BroadcastingsNewBroadcastingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
